import {
  ECONOMY,
  QUANTUM,
  DELUXE,
  STANDARD,
  CORE,
  CHOICE,
  EPIC,
  BTM,
  FIXED,
  DENTAL_STAND_ALONE,
  ECONOMY_NAME,
  QUANTUM_NAME,
  DELUXE_NAME,
  STANDARD_NAME,
  CORE_NAME,
  CHOICE_NAME,
  EPIC_NAME,
  BTM_KEY,
  DENTAL_STAND_ALONE_NAME,
  FBM_KEY,
  LATITUDE,
  LATITUDE_NAME,
  SURE_CARE,
  SURE_CARE_NAME
} from 'core/constants/products'

const TO_ID = {
  [ECONOMY_NAME]: ECONOMY,
  [QUANTUM_NAME]: QUANTUM,
  [DELUXE_NAME]: DELUXE,
  [STANDARD_NAME]: STANDARD,
  [CORE_NAME]: CORE,
  [CHOICE_NAME]: CHOICE,
  [EPIC_NAME]: EPIC,
  [BTM_KEY]: BTM,
  [DENTAL_STAND_ALONE_NAME]: DENTAL_STAND_ALONE,
  [SURE_CARE]: SURE_CARE
}

const TO_STRING = {
  [ECONOMY]: ECONOMY_NAME,
  [QUANTUM]: QUANTUM_NAME,
  [DELUXE]: DELUXE_NAME,
  [STANDARD]: STANDARD_NAME,
  [CORE]: CORE_NAME,
  [CHOICE]: CHOICE_NAME,
  [EPIC]: EPIC_NAME,
  [BTM]: BTM_KEY,
  [DENTAL_STAND_ALONE]: DENTAL_STAND_ALONE_NAME,
  [FIXED]: FBM_KEY,
  [LATITUDE]: LATITUDE_NAME,
  [SURE_CARE]: SURE_CARE_NAME
}

export const toString = id => TO_STRING[id]

export const toId = type => TO_ID[type]
